export enum EPaymentIntentStatus {
  RequiresPaymentMethod = "requiresPaymentMethod",
  RequiresConfirmation = "requiresConfirmation",
  RequiresAction = "requiresAction",
  RequiresCapture = "requiresCapture",
  Processing = "processing",
  Succeeded = "succeeded",
  Canceled = "canceled",
}
